import axiosApiInstance from '../../interceptors/axiosApiInstance';
import { BASE_URL } from '../config';

const GlobalAnnouncementService = {
    getAll: async function (page = 1, pageSize = 10) {
        try {
            const response = await axiosApiInstance.get(BASE_URL + '/global-announcement', {
                params: { page, pageSize }
            });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getActive: async function (page = 1, pageSize = 10, includeTest = false) {
        try {
            const response = await axiosApiInstance.get(BASE_URL + '/global-announcement/active', {
                params: { page, pageSize, includeTest: includeTest ? 'true' : undefined }
            });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getBanners: async function ({ page = 1, pageSize = 1, excludeIds = [], includeTest = false } = {}) {
        try {
            const response = await axiosApiInstance.get(BASE_URL + '/global-announcement/banner', {
                params: {
                    page,
                    pageSize,
                    includeTest: includeTest ? 'true' : undefined,
                    excludeIds: excludeIds.length ? excludeIds.join(',') : undefined
                }
            });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getById: async function (id) {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/global-announcement/${id}`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    create: async function (data) {
        try {
            const response = await axiosApiInstance.post(BASE_URL + '/global-announcement', data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    update: async function (id, data) {
        try {
            const response = await axiosApiInstance.put(BASE_URL + `/global-announcement/${id}`, data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    delete: async function (id) {
        try {
            const response = await axiosApiInstance.delete(BASE_URL + `/global-announcement/${id}`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    }
};

export default GlobalAnnouncementService;
